module.exports = __webpack_public_path__ + "img/NZ.ad363652.svg";